import { SessionInfo } from "@/contexts/AuthContext";
import config from "@/libs/config";
import jwt_decode, { JwtPayload } from "jwt-decode";

export const serviceLogin = (
  callbackURL: string,
  sessionInfo: SessionInfo,
  params: any = {}
) => {
  setTokenCookie("id_token", sessionInfo?.idToken || "");
  setTokenCookie("access_token", sessionInfo?.accessToken || "");
  setRefreshTokenCookie(
    sessionInfo?.refreshToken || "",
    sessionInfo?.accessToken || ""
  );

  const clientID = config.COGNITO_SERVER_CLIENT_ID;
  let loginURL = `/oauth2/authorize?response_type=code&client_id=${clientID}&redirect_uri=${callbackURL}`;
  if (params && params.state) {
    loginURL += `&state=${encodeURIComponent(params.state)}`;
  }
  window.location.href = loginURL;
};

const setTokenCookie = (type: string, token: string) => {
  const tokenDecoded = jwt_decode<JwtPayload>(token);
  const tokenExpiry = tokenDecoded.exp || 0;
  setCookie(type, token, tokenExpiry, true);
};

const setRefreshTokenCookie = (refreshToken: string, accessToken: string) => {
  const tokenDecoded = jwt_decode<JwtPayload>(accessToken);
  const tokenExpiry = tokenDecoded.exp || 0;
  setCookie("refresh_token", refreshToken, tokenExpiry, true);
};

const setCookie = (
  name: string,
  value: string,
  expiry: number,
  secure: boolean
) => {
  let expires = "";
  let secureText = "";
  if (expiry) {
    let date = new Date(expiry * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  if (secure) {
    // Browser will only send cookie over secure HTTPS connections.
    secureText = "; secure";
  }
  document.cookie =
    name +
    "=" +
    (value || "") +
    expires +
    "; path=/oauth2/authorize" +
    secureText;
};

export const removeCookies = () => {
  removeCookie("id_token");
  removeCookie("access_token");
  removeCookie("refresh_token");
};

const removeCookie = (name: string) => {
  document.cookie = name + "=; max-age=0; path=/oauth2/authorize";
};
